import moment from "moment";
import { AccessesFromLog, ISearchAccessesResult } from "../../services/ResourceRelationsService";
import { IBaseSearchResult, IRelationData } from "../Relations/Models";
import { IAccessRelationData, IRolePerrmission } from "./AccessDomainModels";
import { IConfig } from "./IModels";

export enum ALERT {
	Loading = 1,
	NoData = 2,
	NoAccess = 3,
	Access = 4,
	/* Bład przy ściąganiu danych.*/
	Error = 5,
	DuplicatedRows = 6,
	DuplicatedAccess = 7,
}

interface IErrorAlertCodeProps {
	allRows: IAccessRelationData[];
	accessesFromLog: AccessesFromLog;
	config: IConfig;
}

export function getErrorAlertCode(props: IErrorAlertCodeProps): ALERT | null {
	for (let item of props.allRows.filter(x => !x.deleted)) {
		const alert = getAccessAlertCode({ ...props, row: item });
		if (alert === ALERT.DuplicatedRows) {
			return ALERT.DuplicatedRows
		}
		if (alert === ALERT.DuplicatedAccess) {
			return ALERT.DuplicatedAccess
		}
	};

	return null;
}

interface IAccessAlertCodeProps {
	row: IAccessRelationData;
	allRows: IAccessRelationData[];
	accessesFromLog: AccessesFromLog;
	config: IConfig;
}

export function getAccessAlertCode(props: IAccessAlertCodeProps): ALERT {
	const row = props.row;

	function hasRole(row: IAccessRelationData, access: ISearchAccessesResult): boolean {
		if (!row.role && !access.rolePermission) {
			return true;
		}

		if (row.role && access.rolePermission == row.role.name) {
			return true;
		}

		return false;
	}

	function hasTime(row: IRelationData, access: IBaseSearchResult): boolean {

		if (access.from && row.to && moment(access.from.dateTimeO) >= row.from && moment(access.from.dateTimeO) >= row.to) {
			return false;
		}
		if (access.to && moment(access.to.dateTimeO) <= row.from && (!row.to || moment(access.to.dateTimeO) <= row.to)) {
			return false;
		}

		return true;
	}

	function hasEmployeeEquals(row: IAccessRelationData, resourceId: number) {
		if (row.employee?.id === resourceId) {
			return true;
		}

		return false;
	}

	function hasResourceEquals(row: IAccessRelationData, resourceId: number) {
		if (row.resource?.id === resourceId) {
			return true;
		}

		return false;
	}

	function hasRoleEquals(row: IAccessRelationData, role: IRolePerrmission): boolean {
		if (!row.role && !role) {
			return true;
		}

		if (role?.id === row.role?.id) {
			return true;
		}

		return false;
	}

	function hasRoleNameEuals(row: IAccessRelationData, role: string): boolean {
		if (!row.role && !role) {
			return true;
		}

		if (role === row.role?.name) {
			return true;
		}

		return false;
	}

	function hasLoginsEquals(row: IAccessRelationData, login: string) {
		if (props.config.fields.login.hidden) {
			return true;
		}

		if (!row.login && !login) {
			return true;
		}

		if (login === row.login) {
			return true;
		}

		return false;
	}

	function hasEnvironmentsEquals(row: IAccessRelationData, environment: string) {
		if (props.config.fields.environment.hidden) {
			return true;
		}

		if (!row.environment && !environment) {
			return true;
		}

		if (environment === row.environment) {
			return true;
		}

		return false;
	}

	if (!row.employee?.id)
		return ALERT.NoAccess;

	let accesseskey = row.employee.id + ":" + row.resource.id;

	if (!props.accessesFromLog) {
		return ALERT.Loading;
	}
	if (!props.accessesFromLog[accesseskey]) {
		return ALERT.Loading;
	}

	let accesses = props.accessesFromLog[accesseskey];
	if (accesses === "error")
		return ALERT.Error;

	if (!Array.isArray(accesses))
		return ALERT.Loading;

	const addedRowsTemp = props.allRows.filter(x => !x.deleted);

	for (let i = 0; i < addedRowsTemp.length; i++) {
		const addedRow = addedRowsTemp[i];
		if (addedRow === row)
			continue;

		if (!hasResourceEquals(row, addedRow.resource.id))
			continue;

		if (!hasEmployeeEquals(row, addedRow.employee?.id))
			continue;

		if (!hasRoleEquals(row, addedRow.role))
			continue;

		if (!hasLoginsEquals(row, addedRow.login))
			continue;

		if (!hasEnvironmentsEquals(row, addedRow.environment)) {
			continue;
		}

		return ALERT.DuplicatedRows;
	}

	accesses = accesses.filter(x => x.isActive && hasRole(row, x));

	for (let i = 0; i < accesses.length; i++) {
		const access = accesses[i];

		if (!access.skipAccessExpirationDate)
			continue;

		if (!hasResourceEquals(row, access.resourceId))
			continue;

		if (!hasEmployeeEquals(row, access.employeeId))
			continue;

		if (!hasRoleNameEuals(row, access.rolePermission))
			continue;

		if (!hasLoginsEquals(row, access.login))
			continue;

		if (!hasEnvironmentsEquals(row, access.environment))
			continue;

		return ALERT.DuplicatedAccess;
	}

	for (let i = 0; i < accesses.length; i++) {
		const access = accesses[i];

		if (!hasResourceEquals(row, access.resourceId))
			continue;

		if (!hasEmployeeEquals(row, access.employeeId))
			continue;

		if (!hasRoleNameEuals(row, access.rolePermission))
			continue;

		if (!hasLoginsEquals(row, access.login))
			continue;

		if (!hasEnvironmentsEquals(row, access.environment)) {
			continue;
		}

		if (!hasTime(row, access)) {
			return ALERT.Access;
		}
	}

	return ALERT.NoAccess;
}